<script setup>
  import { useMediaQuery } from '@/composables/useMediaQuery';

  import CompleteReportHeaderSecondaryActionList from '@/components/CompleteReportHeaderSecondaryActionList.vue';

  const showSettingsModal = defineModel('showSettingsModal', { required: true });

  const isDesktop = useMediaQuery('(min-width: 840px)');
</script>

<template>
  <div v-if="isDesktop" class="jwx-page-header__secondary-content jwx-page-block jwx-page-block--padding-sm">
    <CompleteReportHeaderSecondaryActionList
      v-model:showSettingsModal="showSettingsModal"
    />
  </div>
</template>